import {
  BiContextProvidedValue,
  BiData,
  SeeAllClickBiEvent,
  ViewSubscriptionTabBiEvent,
  ViewTierUniqueBiEvent,
} from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { PapiDeviation } from '@wix/da-papi-types';
import camelCase from 'lodash/camelCase';
import { DeviationResourceType } from '../types/deviation';
import { GallectionResourceType } from '../types/gallection';
import { ResourceType } from '../types/resource';
import { getBasicTierSubscriptionInfo } from '../utils/hooks/useSubscriptionTier';

/*
    The helpers in this file exist to contain as much of the special casing for
    various blocks as possible. If you find yourself writing something checking
    for contentType, see if it can be extracted here instead of hiding in more
    general components.
 */

export function getMoreByLinkType(contentType: string) {
  switch (contentType) {
    case 'gallery':
      return 'gallery';
    default:
  }
}

export function getBlockBI(contentType: string): Record<string, string | number> {
  const biData: Record<string, string | number> = {
    sectionname: camelCase(contentType),
  };

  switch (contentType) {
    case 'gallery':
      biData.section_typeid = GallectionResourceType.GALLERY;
      break;
    case 'collections': {
      biData.section_typeid = GallectionResourceType.COLLECTION;
      break;
    }
    default:
  }

  return biData;
}

export function getSeeAllBI(contentType: string, deviation: PapiDeviation) {
  const biData = BiData<SeeAllClickBiEvent>({
    evid: 106,
    sectionname: BiContextProvidedValue,
  });

  switch (contentType) {
    case 'in_tier':
    case 'more_tiers':
    case 'selected_tier':
      const { isTier, tier } = getBasicTierSubscriptionInfo(deviation);
      return BiData<ViewSubscriptionTabBiEvent>({
        evid: 547,
        itemid: tier?.deviationId ?? 0,
        typeid: DeviationResourceType.TIER,
        referral_info: isTier
          ? ReferralType.COMPARE_TIER_UNIQUE
          : ReferralType.COMPARE_CONTENT_PAGE,
      });
    default:
  }

  return biData;
}

export function getTierListCardBI(contentType: string, deviation: PapiDeviation): any {
  const biData = BiData<ViewTierUniqueBiEvent>({
    evid: 545,
    referral_info: ReferralType.SIDE_BAR_TIER_UNIQUE,
    itemid: deviation.deviationId,
    typeid: ResourceType.TIER,
  });

  switch (contentType) {
    case 'in_tiers':
      biData.referral_info = ReferralType.SIDE_BAR_CONTENT_PAGE;
      break;
    default:
  }

  return biData;
}
